import { Caution } from "@faire/slate-icons/Caution";
import { CheckOutline } from "@faire/slate-icons/CheckOutline";
import { Exclamation } from "@faire/slate-icons/Exclamation";
import { Information } from "@faire/slate-icons/Information";
import { SVGIconProps } from "@faire/slate-icons/types";
import React from "react";

import { MessagingBannerVariant } from "./types";

/** Returns the consumer's `Icon` for `neutral`/`custom`, else a fixed icon. */
export const getMessagingBannerIcon = (
  variant: MessagingBannerVariant,
  Icon: React.FC<SVGIconProps> | undefined
): React.FC<SVGIconProps> | undefined => {
  if (variant === "custom" || variant === "neutral") {
    return Icon;
  }
  if (variant === "info") {
    return Icon ?? FIXED_VARIANT_ICONS[variant];
  }
  return FIXED_VARIANT_ICONS[variant];
};

const FIXED_VARIANT_ICONS: Record<
  Exclude<MessagingBannerVariant, "custom" | "neutral">,
  React.FC<SVGIconProps>
> = {
  info: Information,
  success: CheckOutline,
  warning: Caution,
  critical: Exclamation,
};
